// // LocalHost Server
// const HTTPS = "http";
// const HOST = "192.168.1.191";
// const PORT = "8081";
// const VERSION = "api/v1";

// Live Server
// const HTTPS = "http";
// const HOST = "3.7.50.140";
// const PORT = "8080";
// const VERSION = "api/v1";

import Constants from '../Constants'

export const BASE_URL = Constants.BACKEND_API_URL + "/api/v1/";

export const getApiBasePath = (basePath, recordId,baseUrl=Constants.BACKEND_API_URL, version="v1") => {
    return baseUrl + "/api/"+version+"/"+basePath;
}


//----------------------------------Base Path----------------------------------
export const USER = "user";
export const ROLE = "role";
export const PERMISSION = "permission";
//Clients Url
export const CLIENT = "client";
export const CLIENT_USER_ACCESS = "client-user-access";
export const CLIENT_LIST_FOR_USER = "list-for-user";

export const DYNAMIC_TABLE = "dynamic-table"
export const MONGO_COMMANDS = "mongo-command";
export const GENERIC_VALIDATION = "generic-validation";
export const GENERIC_RESPONSE_PARAMETER = "generic-response-attribute"
export const GENERIC_REQUEST_PARAMETER = "generic-request-parameter"
export const GENERIC_REQUEST = "genric-request"
export const DYNAMIC_TABLE_ATTRIBUTE = "dynamic-table-attribute"
export const MODULE = "module"
export const DASHBOARD = "dashboard"
export const DASHBOARD_DETAIL = "dashboard-detail"
export const DASHBOARD_ITEMS = "dashboard-items"
export const DASHBOARD_USERS = "dashboard-users"
export const GET_PERMISSION_MODULE_WISE = "get-permission-module-wise"
export const GENERIC_DATA_CREATE_DEFAULT_TABLE = "app-config/create-default-tables"

export const WORKFLOW = "workflows"



//--------------------------------------Generic path------------------------------
export const LIST = "list";
export const ADD_UPDATE = "add-update";
export const DELETE = "delete/{recordId}";
export const VIEW = "{recordId}";
export const COMMAND = "COMMAND";
export const UPDATE = "UPDATE";



//--
export const GENERIC_PAGINATED = "get-paginated-list"
export const GENERIC_LIST = "get-list"
export const GENERIC_DATA_CREATE = "create"
export const GENERIC_DATA_EDIT = "edit"
export const GENERIC_DATA_HARD_DELETE = "hard-delete"
export const GENERIC_PAGINATED_KEY_VALUE_LIST = "get-paginated-key-value-list"
export const GENERIC_DATA_ACTIVE =  "active"
export const GENERIC_DATA_IN_ACTIVE = "in-active"

// Table Import
export const GENERIC_DATA_CREATE_TABLES_WITH_ATTRIBUTES = "dynamic-table/create-tables-with-attributes"

//----------------------------------------------------------------------------------

export const getApiPath = (basePath, gerericApi, recordId,baseUrl=Constants.BACKEND_API_URL, version="v1") => {
    let url = baseUrl + "/api/"+version+"/"+basePath;
    if(gerericApi){
        switch (gerericApi) {
            case VIEW:
                return url + "/"+recordId;
        case COMMAND:
            return url ;
        case UPDATE:
            return url + "/"+recordId; ;
        default:
            return url+"/"+gerericApi;
        }
    }else{
        return url;
    }
}

export const jsonToQueryString = (json) => {
    return Object.entries(json)
        .map(([key, value]) => {
            if (Array.isArray(value)) {
                return value
                    .map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`)
                    .join("&");
            } else if (value !== null && value !== undefined) {
                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            }
            return null; // Skip null or undefined values
        })
        .filter((param) => param !== null) // Remove skipped entries
        .join("&");
}


// Table Attribute Master
export const DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET = getApiBasePath(DYNAMIC_TABLE_ATTRIBUTE) + "/list-by-table-id/{dynamic-table-id}"

// Request Parameter Master
export const PARTICULAR_REQUEST_PARAMETER_LIST_GET = getApiBasePath(GENERIC_REQUEST_PARAMETER) + "/list-by-request-id/{request-id}";

// Response Attribute Master
export const PARTICULAR_RESPONSE_PARAMETER_LIST_GET = getApiBasePath(GENERIC_RESPONSE_PARAMETER) + "/list-by-request-id/{request-id}";

// Generic Validation Controller 
export const VALIDATION_BY_PARAMETER_LIST = getApiBasePath(GENERIC_VALIDATION) + "/validation-by-parameter/{generic-parameter-id}";

// Clients Users List 
export const GET_CLIENTS_USERS = getApiBasePath(CLIENT) + "/users/{clientId}";
export const ASSIGN_CLIENT_TO_USER = getApiBasePath(CLIENT) + "/assign-client-to-user/{clientId}";
export const REMOVE_CLIENT_FROM_USER = getApiBasePath(CLIENT) + "/remove-client-from-user/{clientId}";


// Client Master
export const CLIENT_DELETE_DELETE = BASE_URL + "client/delete/{clientId}";
export const CREATE_CLIENT_POST = BASE_URL + "client/create";

//Permission
export const UPDATE_PERMISSION_FOR_USER = getApiBasePath(USER)+"/assign-permission/{userId}"
export const GET_PERMISSIONS_FOR_USER = getApiBasePath(USER)+"/user-permissions/{userId}"

//dashboard
export const DASHBOARD_ITEMS_BY_DASHBOARD_ID = "dashboard/{dashboardId}"
export const GET_DASHBOARD_FOR_USER = getApiBasePath(DASHBOARD)+"/get-dashboard-for-user"

// Prompt Editor
export const PROMPT_EDITOR_CREATE = "http://localhost:8060/gen-ai-service-autocode/api/ask"

// get config data types

export const GET_CONFIG_DATA_TYPES = BASE_URL +"app-config/get-data-type-config"
